export default "__VITE_ASSET__Bek$0YoQ__"